 


import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router'; 

import { AgencyComponent } from './agency.component';
import { ViewagentComponent } from './viewagent.component';
import { AddagentComponent } from './addagent.component'; 
import { AddagentpicComponent } from './addagentpic.component'; 
import { AddagentceoComponent } from './addagentceo.component'; 
import { AssignedComponent } from './assigned.component';
import { ExpiredComponent } from './expired.component'; 
import { ChangeagentComponent } from './changeagent.component'; 
import { ViewagentperformanceComponent } from './viewagentperformance.component'; 
import { RepoagencyComponent } from './repoagency.component'; 
import { ViewrepoagentComponent } from './viewrepoagent.component';
import { AddrepoagentComponent } from './addrepoagent.component'; 
import { Addrepoagent2Component } from './addrepoagent2.component'; 
import { Addrepoagent3Component } from './addrepoagent3.component';  
import { EditagentComponent } from './editagent.component'; 
import { Editagent2Component } from './editagent2.component'; 
import { Editagent3Component } from './editagent3.component'; 
import { AgencyassignmentComponent } from './agencyassignment.component'; 
import { DiscountrequestedComponent } from './discountrequested.component';

import { AdduserComponent } from './adduser.component';
// Auth
import { AuthGuard } from '../_guards/index';

const routes: Routes = [
  {
    path: '',
    data: {
      title: 'Agencies'
    }, 
    canActivate: [AuthGuard],
    children: [
      {
        path: 'adduser',
        component: AdduserComponent,
        data: {
          title: 'Add user'
        }
      },
      {
        path: 'agencyassignment/:id',
        component: AgencyassignmentComponent,
        data: {
          title: 'Agency Assignment'
        }
      },
      {
        path: 'agency',
        component: AgencyComponent, 
        data: {
          title: 'Agency'
        }
      },
      {
        path: 'agency/:page',
        component: AgencyComponent, 
        data: {
          title: 'Agency'
        }
      },
      {
        path: 'viewagent/:id',
        component: ViewagentComponent,
        data: {
          title: 'Agency'
        }
      },
      {
        path: 'addagent',
        component: AddagentComponent,
        data: {
          title: 'Add Agency'
        }
      },
      {
        path: 'assigned',
        component: AssignedComponent, 
        data: {
          title: 'Assigned'
        }
      }, 
      {
        path: 'changeagent/:id',
        component: ChangeagentComponent, 
        data: {
          title: 'Aborted' 
        }
      },
      {
        path: 'viewagentperformance/:id',
        component: ViewagentperformanceComponent, 
        data: {
          title: 'Agency Performance' 
        }
      },
      {
        path: 'addagentpic/:id',
        component: AddagentpicComponent, 
        data: {
          title: 'Add Agency PIC' 
        }
      },
      {
        path: 'addagentceo/:id',
        component: AddagentceoComponent, 
        data: {
          title: 'Add Agency' 
        }
      }, 
      {
        path: 'addrepoagent',
        component: AddrepoagentComponent, 
        data: {
          title: 'Add Repo Agency' 
        }
      },
      {
        path: 'addrepoagent2',
        component: Addrepoagent2Component, 
        data: {
          title: 'Add Repo Agency' 
        }
      },
      {
        path: 'addrepoagent3',
        component: Addrepoagent3Component, 
        data: {
          title: 'Add Repo Agency' 
        }
      },
      {
        path: 'repoagency',
        component: RepoagencyComponent, 
        data: {
          title: 'Repo Agency' 
        }
      },
      {
        path: 'viewrepoagent/:id',
        component: ViewrepoagentComponent, 
        data: {
          title: 'View Repo Agency' 
        }
      }, 
      {
        path: 'editagent/:id',
        component: EditagentComponent, 
        data: {
          title: 'Edit Agency' 
        }
      },
      {
        path: 'editagent2/:id',
        component: Editagent2Component, 
        data: {
          title: 'Edit Agency' 
        }
      },
      {
        path: 'editagent3/:id',
        component: Editagent3Component, 
        data: {
          title: 'Edit Agency' 
        } 
      },
      {
        path: 'discountrequested',
        component: DiscountrequestedComponent, 
        data: {
          title: 'Discount' 
        } 
      },
      {
        path: 'expired',
        component: ExpiredComponent, 
        data: {
          title: 'Abortion' 
        } 
      },
    ] 
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],  
  exports: [RouterModule]
})
export class AgenciesRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/agencies/agencies-routing.module.ts